import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { object, string, bool, func } from "prop-types";

import RightArrow from "../../atoms/icons/right-arrow";

import { staticTexts } from "../../utils/Translate";

import "./filternavigation.m.css";

const FilterList = ({ currentUrl, paramsName, toggleCollapse, isMobile, widgetHeight }) => {
  const dataList = widgetHeight
    ? widgetHeight.split(",").map((data) => {
        const keyValue = data.split(":");
        return {
          key: keyValue[0] && keyValue[0].trim(),
          value: keyValue[1] && keyValue[1].trim(),
        };
      })
    : [];
  return (
    <div styleName="navigation-filter">
      <div styleName="navigation-filter-text">{staticTexts().filter}</div>
      {dataList.map((data, index) => (
        <Link
          key={index}
          href={`/${currentUrl}?slug=${data.value}`}
          styleName={`navigation-filter-name ${data.value === paramsName ? "active-name" : ""}`}
        >
          {data.key}
        </Link>
      ))}
      {isMobile && (
        <div styleName="icon-filter">
          <div styleName="down-icon" onClick={toggleCollapse}>
            <div styleName="icon-rotate">
              <RightArrow arrowColor="#fff" height="11" width="11" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const FilterNavigation = ({ sectionsDataForHeader, widgetHeight }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [paramsName, setParamsName] = useState("");
  const [collapse, setCollapse] = useState(false);

  const toggleCollapse = () => {
    setCollapse(!collapse);
  };

  useEffect(() => {
    setIsMobile(global.deviceWidth < 876);
    const urlParams = new URLSearchParams(window.location.search);
    const params = urlParams.get("slug");
    if (params) {
      setParamsName(params);
    }
  }, []);

  const url = sectionsDataForHeader.currentSectionUrl.split("/");
  const currentUrl = url.length > 4 ? url[url.length - 2] + "/" + url[url.length - 1] : url[url.length - 1];

  if (isMobile) {
    return (
      <>
        {!collapse && (
          <div styleName="navigation-filter-mobile">
            <div styleName="navigation-filter-text navigation-name" onClick={toggleCollapse}>
              {staticTexts().filter}
            </div>
            <div styleName="icon-filter">
              <div styleName="down-icon up-icon" onClick={toggleCollapse}>
                <div styleName="icon-rotate icon-rotate-down">
                  <RightArrow arrowColor="#fff" height="11" width="11" />
                </div>
              </div>
            </div>
          </div>
        )}
        {collapse && (
          <FilterList
            currentUrl={currentUrl}
            paramsName={paramsName}
            toggleCollapse={toggleCollapse}
            isMobile={isMobile}
            widgetHeight={widgetHeight}
          />
        )}
      </>
    );
  }
  return <FilterList currentUrl={currentUrl} paramsName={paramsName} widgetHeight={widgetHeight} />;
};

FilterList.propTypes = {
  currentUrl: string,
  paramsName: string,
  toggleCollapse: func,
  isMobile: bool,
  widgetHeight: string,
};

FilterNavigation.propTypes = {
  sectionsDataForHeader: object,
  widgetHeight: string,
};

export default FilterNavigation;
